import React, { useRef } from 'react';
import { NavItem } from '../../../shared';

import Link from '../../../../Link';
import { Dropdown } from './Dropdown';

import {
  NavLinkWrapper,
  NavLink,
  PositionDropdown,
  NavlinkArrow,
  PositionCarets,
  DropdownCaret
} from '../DesktopNavbar.styles';

import downArrow from '@/images/arrow-down.svg';

interface NavigationLinkProps extends NavItem {
  selected: boolean;
  setSelected: (val: string | undefined) => void;
}

export function NavigationLink({
  name,
  title,
  url,
  links,
  selected,
  setSelected
}: NavigationLinkProps) {
  const navItemRef = useRef<HTMLAnchorElement>(null);

  const toggleDropdown = () => {
    if (selected) {
      setSelected(undefined);
    } else {
      setSelected(name || title);
    }
  };

  return (
    <NavLinkWrapper>
      <NavLink
        aria-controls={`nav-expanded-content-${name}`}
        aria-expanded={selected}
        onClick={toggleDropdown}
        onMouseEnter={toggleDropdown}
        onMouseLeave={toggleDropdown}
      >
        <Link
          href={links ? '#0' : (url as string)}
          ref={navItemRef}
          onClick={(e) => {
            if (links) {
              e.preventDefault();
            }
          }}
        >
          {name || title}
        </Link>
        {links && (
          <>
            <PositionCarets>
              <NavlinkArrow src={downArrow} alt="down-arrow" />
              <DropdownCaret displayDropdown={selected} />
            </PositionCarets>
            <PositionDropdown id={`nav-expanded-content-${name}`}>
              <Dropdown displayDropdown={selected} links={links} />
            </PositionDropdown>
          </>
        )}
      </NavLink>
    </NavLinkWrapper>
  );
}
